import { $http } from "@/assets/js/appFunc";

export const saveEntityData = (context, payload) => {
    const req = {
        type: "POST",
        url: "/globaldata/entity/persist/values",
        data: payload
    };
    return $http(req, true).then(data => data,
        error => error);
};

export const getEntityData = (context, payload) => {
    const req = {
        type: "POST",
        url: "/globaldata/entity/value/get/paginated",
        data: payload
    };
    return $http(req, true).then(data => data,
        error => error);
};
export const getExternalEntityData = (context, payload) => {
    const req = {
        type: "GET",
        url: `/globaldata/entity/external/${payload.entityCode}/data/${payload.from}/${payload.to}`,
        noNotify: true
    };
    return $http(req, true);
};
export const getSavedExternaStructure = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/globaldata/entity/external/saved/${entityCode}`
    };
    return $http(req, true);
};
export const getRefreshStructure = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/globaldata/entity/external/${entityCode}`
    };
    return $http(req, true);
};
export const getExternalDescriptor = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/globaldata/swagger/generate/external/entity/${entityCode}`
    };
    return $http(req, true);
};

export const addNewEntityGDM = (context, payload) => {
    const req = {
        type: "POST",
        url: "/globaldata/entity/updateorinsert",
        data: payload
    };
    return $http(req, true).then(data => data,
        error => error);
};
export const addAttributesGDM = (context, payload) => {
    const req = {
        type: "POST",
        url: "/globaldata/attribute/updateorinsert",
        data: payload
    };
    return $http(req, true).then(data => data,
        error => error);
};

export const deleteEntity = (context, entityCode) => {
    const req = {
        type: "POST",
        url: `/globaldata/entity/delete/${entityCode}`,
        data: entityCode
    };
    return $http(req, true);
};

export const deleteIntegration = (context, connectionCode) => {
    const req = {
        type: "DELETE",
        url: `/globaldata/connector/${connectionCode}`
    };
    return $http(req, true);
};

export const getEntity = (context, entityCodes) => {
    const req = {
        type: "POST",
        url: "/globaldata/entity/get",
        data: entityCodes
    };
    return $http(req, true);
};

export const getAttributes = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/globaldata/attribute/entityCode/${entityCode}`
    };
    return $http(req, true);
};

export const deleteRows = (context, payload) => {
    const req = {
        type: "POST",
        url: "/globaldata/entity/values/delete",
        data: payload
    };
    return $http(req, true);
};

export const isEntityPublished = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/globaldata/entity/published?entityCode=${entityCode}`
    };
    return $http(req, true);
};

export const deleteAttribute = (context, codes) => {
    const req = {
        type: "DELETE",
        url: `/globaldata/attribute/${codes.attributeCode}/entity/${codes.entityCode}`
    };
    return $http(req, true);
};

export const isAttributePublished = (context, codes) => {
    const req = {
        type: "GET",
        url: `/globaldata/attribute/${codes.attributeCode}/entity/${codes.entityCode}/is/published`
    };
    return $http(req, true);
};

export const editAttribute = (context, payload) => {
    const req = {
        type: "PUT",
        url: `/globaldata/attribute/${payload.code}/entity/${payload.entityCode}`,
        data: payload
    };
    return $http(req, true);
};

export const testItegrationConn = (context, payload) => {
    const req = {
        type: "POST",
        data: payload,
        url: "/globaldata/connector/testConnection"
    };
    return $http(req, true);
};
export const saveIntegration = (context, payload) => {
    const req = {
        type: "POST",
        url: "/globaldata/connector",
        data: payload
    };
    return $http(req, true);
};
export const getIntegrations = () => {
    const req = {
        type: "POST",
        url: "/globaldata/connector/value/get/paginated",
        data: {
            pageNr: 0,
            size: 999999
        }
    };
    return $http(req, true);
};

export const checkIntegration = (context, payload) => {
    const req = {
        type: "GET",
        url: `/globaldata/connector/testConnection/${payload}`
    };
    return $http(req, true);
};

export const updateIntegration = (context, payload) => {
    const req = {
        type: "PATCH",
        url: "/globaldata/connector",
        data: payload
    };
    return $http(req, true);
};

export const getSchemas = (context, code) => {
    const req = {
        type: "GET",
        url: `/globaldata/connector/${code}/query/schemas`
    };
    return $http(req, true);
};

export const getTables = (context, payload) => {
    const req = {
        type: "GET",
        url: `/globaldata/connector/${payload.code}/query/schema/${payload.schema}/viewsAndTables`
    };
    return $http(req, true);
};

export const pullStructure = (context, payload) => {
    const req = {
        type: "GET",
        url: `/globaldata/connector/${payload.code}/query/schema/${payload.schema}/table/${payload.table}/attributes`
    };
    return $http(req, true);
};

export const saveExternalEntity = (context, payload) => {
    const req = {
        type: "POST",
        url: "/globaldata/entity/external",
        data: payload
    };
    return $http(req, true);
};
export const isIntegrationUsed = (context, connectionCode) => {
    const req = {
        type: "GET",
        url: `/globaldata/connector/${connectionCode}/isDeletable`
    };
    return $http(req, true);
};
export const updateExternalEntity = (context, payload) => {
    const req = {
        type: "PUT",
        url: "/globaldata/entity/external",
        data: payload
    };
    return $http(req, true);
};
export const validateExcelImport = (context, { entityCode, payload }) => {
    const req = {
        type: "POST",
        url: `/globaldata/import/xlsx/validate/data/${entityCode}`,
        data: payload,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };
    return $http(req, true);
};
export const exportExcel = (context, { type, code }) => {
    const req = {
        type: "GET",
        url: `/globaldata/export/xlsx/${type}/${code}`,
        responseType: "arraybuffer"
    };
    return $http(req, true);
};
export const getExcelTemplate = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/globaldata/export/data/template//${entityCode}`,
        responseType: "arraybuffer"
    };
    return $http(req, true);
};
export const importEntityData = (context, { entityCode, payload }) => {
    const req = {
        type: "POST",
        url: `/globaldata/import/xlsx/data/${entityCode}`,
        data: payload,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };
    return $http(req, true);
};
export const actExportExcelByEmail = (context, { typeOfExport, entityCode }) => {
    const req = {
        type: "GET",
        url: `/globaldata/sendToEmail/xlsx/${typeOfExport}/${entityCode}`
    };
    return $http(req, true);
};

export const getEntityStatusInfo = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/globaldata/entity/${entityCode}/publish/status`
    };
    $http(req, true).then(
        data => context.commit("setEntityInFocusStatus", data.data)
    );
};
export const publishEntity = (context, entityCode) => {
    const req = {
        type: "POST",
        url: `/globaldata/entity/${entityCode}/publish`
    };
    return $http(req, true);
};

export const addNewEntityDataStore = (context, payload) => {
    const req = {
        type: "POST",
        noNotify: true,
        url: "/datastore/entities",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getEntityDataStore = () => {
    const req = {
        type: "GET",
        url: "/datastore/entities"
    };
    return $http(req, true);
};
